module.exports = __webpack_public_path__ + "static/media/VV 1.5662e1b6.mp3";